import { render, staticRenderFns } from "./DepartmentCreateModal.vue?vue&type=template&id=010d8b19&scoped=true"
import script from "./DepartmentCreateModal.vue?vue&type=script&lang=js"
export * from "./DepartmentCreateModal.vue?vue&type=script&lang=js"
import style0 from "./DepartmentCreateModal.vue?vue&type=style&index=0&id=010d8b19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010d8b19",
  null
  
)

export default component.exports